import React, { useContext, useEffect, useState } from "react";

// styles
import Style from "../ModalSettings.module.css";

// external components
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ModalSettingsContext } from "../../../../../../context/ModalSettingsContext";
// delete department
import { deleteDepartment } from "../departmentApi";
const Department = ({
  departmentName,
  headOfDepartmentName,
  departmentIdNumber,
}) => {
  const [departmentId, setDepartmentId] = useState("");
  const {
    setDepartments,
    setIsEditing,
    setEditingDepartmentId,
    setNewDepartmentData,
  } = useContext(ModalSettingsContext);

  // Delete an existing department
  const handleDeleteDepartment = async () => {
    const confirm = window.confirm(
      `Are you sure you want to delete department ${departmentName}?`
    );
    if (!confirm) return;

    try {
      await deleteDepartment(departmentId);
      setDepartments((prev) =>
        prev.filter((department) => department.id !== departmentId)
      );

      // Optionally, update the state or perform any other actions after deleting the department
    } catch (error) {
      console.error("Error deleting department:", error);
      window.alert("Greška u brisanju odjela!");
    }
  };

  const handleEditClick = () => {
    setIsEditing(true);
    setEditingDepartmentId(departmentId);
    setNewDepartmentData({
      name: departmentName,
      headName: headOfDepartmentName,
    });
  };

  useEffect(() => {
    setDepartmentId(departmentIdNumber);
  }, [departmentIdNumber]);

  return (
    <div className={Style.DepartmentContainer}>
      <div className={Style.DepartmentInfo}>
        <div className={Style.DepartmentInfoElement}>{departmentName}</div>
        <div> - </div>
        <div className={Style.DepartmentInfoElement}>
          {headOfDepartmentName}
        </div>
      </div>
      <div className={Style.DepartmentIconContainer}>
        <FontAwesomeIcon
          onClick={() => handleDeleteDepartment()}
          icon={faTrash}
        />
        <FontAwesomeIcon
          onClick={() => handleEditClick()}
          icon={faPenToSquare}
        />
      </div>
    </div>
  );
};

export default Department;
